/**
 * Badge information for displaying in tables and components across the application
 * Useful for category, state, etc.
 */
export class BadgeInfo {
  constructor(
    public readonly id: number,
    public readonly text: string,
    public readonly colorClasses: string, // Tailwind CSS classes for color
    public readonly iconClasses: string // Tailwind CSS classes for icons
  ) {}
}
